var chunkMapping = {
	"node_modules_pnpm_babel_runtime_7_12_1_node_modules_babel_runtime_helpers_esm_defineProperty_-39fd5f": [
		"webpack/container/remote/base/i18n",
		"webpack/container/remote/widgets/feedback",
		"webpack/container/remote/widgets/popover",
		"webpack/container/remote/widgets/menu",
		"webpack/container/remote/widgets/basedropdown"
	],
	"webpack_sharing_consume_default_zustand_zustand-webpack_container_remote_base_services-webpac-596bb4": [
		"webpack/container/remote/base/stores",
		"webpack/container/remote/widgets/datadisplay",
		"webpack/container/remote/widgets/richtext",
		"webpack/container/remote/widgets/inputs",
		"webpack/container/remote/base/services"
	],
	"webpack_container_remote_base_classes-webpack_container_remote_kfplatform_filePreview-webpack-3eb00b": [
		"webpack/container/remote/base/classes",
		"webpack/container/remote/kfplatform/filePreview",
		"webpack/container/remote/widgets/scrollbar"
	],
	"src_components_forum_topic_detail_jsx": [
		"webpack/container/remote/widgets/infinitescroll",
		"webpack/container/remote/widgets/validation"
	],
	"common_src_store_comment_store_js": [
		"webpack/container/remote/base/utils"
	],
	"src_empty_state_index_jsx-webpack_sharing_consume_default_react-router-dom_react-router-dom": [
		"webpack/container/remote/widgets/layouts"
	],
	"webpack_container_remote_base_constants-webpack_container_remote_widgets_others": [
		"webpack/container/remote/base/constants",
		"webpack/container/remote/widgets/others"
	],
	"src_components_mention_list_index_jsx-src_components_post_embedurl_index_jsx-src_container_fe-cbe96b": [
		"webpack/container/remote/kfplatform/filePicker",
		"webpack/container/remote/widgets/emojigifpicker",
		"webpack/container/remote/widgets/spinner",
		"webpack/container/remote/widgets/modal",
		"webpack/container/remote/widgets/navigation",
		"webpack/container/remote/widgets/lazyloader",
		"webpack/container/remote/widgets/flowicon"
	],
	"webpack_container_remote_widgets_datetime": [
		"webpack/container/remote/widgets/datetime"
	],
	"webpack_container_remote_widgets_tab": [
		"webpack/container/remote/widgets/tab"
	],
	"src_components_comment_index_jsx": [
		"webpack/container/remote/kfcomponents/printStore",
		"webpack/container/remote/kfplatform/constants"
	],
	"src_channel_component_jsx-src_empty_state_empty_state_css": [
		"webpack/container/remote/widgets/singleselect"
	],
	"src_components_members_index_jsx": [
		"webpack/container/remote/widgets/personcard",
		"webpack/container/remote/widgets/sharesettings"
	]
};
var idToExternalAndNameMapping = {
	"webpack/container/remote/base/i18n": [
		"default",
		"./i18n",
		"webpack/container/reference/base"
	],
	"webpack/container/remote/widgets/feedback": [
		"default",
		"./feedback",
		"webpack/container/reference/widgets"
	],
	"webpack/container/remote/widgets/popover": [
		"default",
		"./popover",
		"webpack/container/reference/widgets"
	],
	"webpack/container/remote/widgets/menu": [
		"default",
		"./menu",
		"webpack/container/reference/widgets"
	],
	"webpack/container/remote/widgets/basedropdown": [
		"default",
		"./basedropdown",
		"webpack/container/reference/widgets"
	],
	"webpack/container/remote/base/stores": [
		"default",
		"./stores",
		"webpack/container/reference/base"
	],
	"webpack/container/remote/widgets/datadisplay": [
		"default",
		"./datadisplay",
		"webpack/container/reference/widgets"
	],
	"webpack/container/remote/widgets/richtext": [
		"default",
		"./richtext",
		"webpack/container/reference/widgets"
	],
	"webpack/container/remote/widgets/inputs": [
		"default",
		"./inputs",
		"webpack/container/reference/widgets"
	],
	"webpack/container/remote/base/services": [
		"default",
		"./services",
		"webpack/container/reference/base"
	],
	"webpack/container/remote/base/classes": [
		"default",
		"./classes",
		"webpack/container/reference/base"
	],
	"webpack/container/remote/kfplatform/filePreview": [
		"default",
		"./filePreview",
		"webpack/container/reference/kfplatform"
	],
	"webpack/container/remote/widgets/scrollbar": [
		"default",
		"./scrollbar",
		"webpack/container/reference/widgets"
	],
	"webpack/container/remote/widgets/infinitescroll": [
		"default",
		"./infinitescroll",
		"webpack/container/reference/widgets"
	],
	"webpack/container/remote/widgets/validation": [
		"default",
		"./validation",
		"webpack/container/reference/widgets"
	],
	"webpack/container/remote/base/utils": [
		"default",
		"./utils",
		"webpack/container/reference/base"
	],
	"webpack/container/remote/widgets/layouts": [
		"default",
		"./layouts",
		"webpack/container/reference/widgets"
	],
	"webpack/container/remote/base/constants": [
		"default",
		"./constants",
		"webpack/container/reference/base"
	],
	"webpack/container/remote/widgets/others": [
		"default",
		"./others",
		"webpack/container/reference/widgets"
	],
	"webpack/container/remote/kfplatform/filePicker": [
		"default",
		"./filePicker",
		"webpack/container/reference/kfplatform"
	],
	"webpack/container/remote/widgets/emojigifpicker": [
		"default",
		"./emojigifpicker",
		"webpack/container/reference/widgets"
	],
	"webpack/container/remote/widgets/spinner": [
		"default",
		"./spinner",
		"webpack/container/reference/widgets"
	],
	"webpack/container/remote/widgets/modal": [
		"default",
		"./modal",
		"webpack/container/reference/widgets"
	],
	"webpack/container/remote/widgets/navigation": [
		"default",
		"./navigation",
		"webpack/container/reference/widgets"
	],
	"webpack/container/remote/widgets/lazyloader": [
		"default",
		"./lazyloader",
		"webpack/container/reference/widgets"
	],
	"webpack/container/remote/widgets/flowicon": [
		"default",
		"./flowicon",
		"webpack/container/reference/widgets"
	],
	"webpack/container/remote/widgets/datetime": [
		"default",
		"./datetime",
		"webpack/container/reference/widgets"
	],
	"webpack/container/remote/widgets/tab": [
		"default",
		"./tab",
		"webpack/container/reference/widgets"
	],
	"webpack/container/remote/kfcomponents/printStore": [
		"default",
		"./printStore",
		"webpack/container/reference/kfcomponents"
	],
	"webpack/container/remote/kfplatform/constants": [
		"default",
		"./constants",
		"webpack/container/reference/kfplatform"
	],
	"webpack/container/remote/widgets/singleselect": [
		"default",
		"./singleselect",
		"webpack/container/reference/widgets"
	],
	"webpack/container/remote/widgets/personcard": [
		"default",
		"./personcard",
		"webpack/container/reference/widgets"
	],
	"webpack/container/remote/widgets/sharesettings": [
		"default",
		"./sharesettings",
		"webpack/container/reference/widgets"
	]
};
__webpack_require__.f.remotes = function(chunkId, promises) {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach(function(id) {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = function(error) {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = function() {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = function(fn, arg1, arg2, d, next, first) {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then(function(result) { return next(result, d); }, onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = function(external, _, first) { return external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError(); };
			var onInitialized = function(_, external, first) { return handleFunction(external.get, data[1], getScope, 0, onFactory, first); };
			var onFactory = function(factory) {
				data.p = 1;
				__webpack_require__.m[id] = function(module) {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}